export class SureFlowLoopDetail {

  id!: number;
  systemTypeCode!: string;
  description!: string;
  coolingEnteringFluidTemperature!: number;
  coolingPeakFluidTemperatureChange!: number;
  coolingTargetSensibleHeatRatio!: number;
  coolingLeavingFluidTemperature!: number;
  coolingPeakTotalCapacity!: number;
  coolingPeakSensibleCapacity!: number;
  coolingActualTotalCapacity!: number;
  coolingActualSensibleCapacity!: number;
  coolingPeakFluidFlowRateLocked!: boolean;
  coolingPeakFluidFlowRate!: number;
  coolingPipeId!: number;
  coolingFluidVelocity!: number;
  coolingFluidTypeCode!: string;
  coolingGlycolPercentage!: number;
  heatingEnteringFluidTemperature!: number;
  heatingPeakFluidTemperatureChange!: number;
  heatingLeavingFluidTemperature!: number;
  heatingPeakTotalCapacity!: number;
  heatingActualTotalCapacity!: number;
  heatingPeakFluidFlowRateLocked!: boolean;
  heatingPeakFluidFlowRate!: number;
  heatingPipeId!: number;
  heatingFluidVelocity!: number;
  heatingFluidTypeCode!: string;
  heatingGlycolPercentage!: number;
  metric!: boolean;
  isEditMode!: boolean;

}
